import ArticleLayout from '@/components/feature/ArticleLayout';
import { ArticleSchema, BreadcrumbListSchema } from '@/components/base/SchemaOrg';

const article = {
  date: '7. Juli 2026',
  updatedDate: '16. Juli 2026',
  readingTime: '5 Min.',
  title: 'OOPBuy Spreadsheet Sets 2026: Beste Outfit-Kombinationen',
  subtitle: 'Komplette Outfits zu unschlagbaren Preisen – die besten Sets im OOPBuy Spreadsheet. Von Sport-Sets bis Casual-Looks.',
  author: 'OOPBuy Redaktionsteam',
  heroImageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20sets%20displayed%20on%20minimalist%20clothing%20rack%2C%20matching%20hoodie%20and%20sweatpants%20in%20sage%20green%2C%20soft%20natural%20window%20light%2C%20modern%20streetwear%20aesthetic%2C%20clean%20beige%20wall%20background%2C%20texture%20details%20visible%2C%20editorial%20lifestyle%20photography&width=1600&height=900&seq=hero-sets-x6&orientation=landscape",
  tableOfContents: [
    { id: 'section-1', label: 'Sets im OOPBuy Spreadsheet' },
    { id: 'section-2', label: 'Beliebte Set-Typen' },
    { id: 'section-3', label: 'Vorteile von Sets' },
    { id: 'section-4', label: 'Top Set-Verkäufer' },
    { id: 'section-5', label: 'Fazit' },
  ],
};

const relatedArticles = [
  { title: 'OOPBuy Spreadsheet Guide', desc: 'Der komplette Leitfaden', link: '/artikel/oopbuy-spreadsheet-guide', isReady: true },
  { title: 'OOPBuy Spreadsheet Hoodie', desc: 'Die besten Hoodies & Pullover', link: '/artikel/oopbuy-spreadsheet-hoodie', isReady: true },
  { title: 'OOPBuy Spreadsheet Jacken', desc: 'Beste Jacken & Mäntel', link: '/artikel/oopbuy-spreadsheet-jacken', isReady: true },
];

export default function SetsPage() {
  return (
    <ArticleLayout article={article} relatedArticles={relatedArticles}>
      <ArticleSchema
        headline={article.title}
        description={article.subtitle}
        image={article.heroImageUrl}
        datePublished="2026-07-07"
        dateModified="2026-07-16"
        authorName={article.author}
        url="https://oopbuyspread.buzz/artikel/oopbuy-spreadsheet-sets"
      />
      <BreadcrumbListSchema items={[
        { name: 'Startseite', item: 'https://oopbuyspread.buzz/' },
        { name: 'OOPBuy Spreadsheet Sets', item: 'https://oopbuyspread.buzz/artikel/oopbuy-spreadsheet-sets' },
      ]} />
      <section id="section-1">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Sets im OOPBuy Spreadsheet</h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
          Die Sets-Kategorie im <strong>OOPBuy Spreadsheet</strong> bietet komplette Outfits zu einem Bruchteil des Einzelpreises. Mit etwa 180 gelisteten Sets findest Du hier alles von sportlichen Trainingsanzügen bis zu eleganten Casual-Kombinationen.
        </p>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
          Ein großer Vorteil: Sets aus dem <strong>oopbuy spreadsheet deutschland</strong> sind farblich und stilistisch perfekt aufeinander abgestimmt – Du sparst Dir das mühsame Kombinieren.
        </p>
      </section>

      <section id="section-2">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Beliebte Set-Typen</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">Typ</th>
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">Preis</th>
                <th className="text-left py-3 px-3 text-foreground-800 font-semibold">Inhalt</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Sport-Set', '€25-55', 'Hoodie + Jogginghose'],
                ['Casual-Set', '€30-65', 'T-Shirt + Shorts/Hose'],
                ['Loungewear', '€35-70', 'Pullover + Hose + Top'],
                ['Winter-Set', '€50-100', 'Jacke + Pullover + Hose'],
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-background-100">
                  <td className="py-3 px-3 text-foreground-800 font-medium">{row[0]}</td>
                  <td className="py-3 px-3 text-foreground-500">{row[1]}</td>
                  <td className="py-3 px-3 text-foreground-500">{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section id="section-3">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Vorteile von Sets</h2>
        <div className="bg-background-100 rounded-2xl p-5 md:p-6">
          <ul className="space-y-2">
            {[
              'Preisvorteil: Sets sind 20-40% günstiger als Einzelkäufe',
              'Perfekte Abstimmung: Farben und Styles passen garantiert zusammen',
              'Weniger Versandkosten: Ein Paket statt mehrerer Einzelsendungen',
              'QC effizienter: Alle Teile werden zusammen geprüft',
            ].map((item, idx) => (
              <li key={idx} className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500 mt-0.5 flex-shrink-0"></i>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section id="section-4">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Top Set-Verkäufer</h2>
        <div className="space-y-3">
          {[
            { name: 'QualityFirst', note: 'Beste Stoffqualität bei Sets' },
            { name: 'BudgetKing', note: 'Größte Set-Auswahl' },
          ].map((s, idx) => (
            <div key={idx} className="flex items-center justify-between bg-white rounded-xl p-4 border border-background-200/70">
              <p className="font-semibold text-sm text-foreground-900">{s.name}</p>
              <p className="text-xs text-foreground-500">{s.note}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="section-5">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Fazit</h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
          Sets aus dem <strong>OOPBuy Spreadsheet</strong> sind der einfachste Weg zu einem kompletten, stilvollen Look – zu Preisen, die Dein Portemonnaie schonen. Die Kombination aus Preisvorteil und perfekter Abstimmung macht sie zu einem der besten Deals im Spreadsheet.
        </p>
      </section>
    </ArticleLayout>
  );
}